import {
  Avatar,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Box,
  Button,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useEffect, useRef, useState } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { s3baseUrl } from "src/config/config";
import Label from "src/components/Label";
import ToshowExercise from "./component/modalToshowExercise";
import { Icon } from "@iconify/react";
import ParameterModel from "./component/ParameterModel";
import InfoIcon from "@mui/icons-material/Info";
import ModalToShowAnExerciseInfo from "./component/ModalToShowAnExerciseInfo";
import { is_small_medium_screen } from "src/utils/constants";

const WorkoutExercisesUI = ({ addArray, setaddArray, setModalChangeExe }) => {
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");
  const [detailsData, setDetailsData] = useState("");
  const [exerIndex, setExerIndex] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenForSuperset, setModalOpenForSuperset] = useState(false);
  const [outerIndex, setOuterIndex] = useState("");
  const [exerInfo, setExsrInfo] = useState([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [isHovered, setIsHovered] = useState("");
  const [isHoveredExercise, setIsHoveredExercise] = useState("");
  const [isExerciseForSuperSet, setIsExerciseForSuperSet] = useState(false);

  const handleMouseEnter = (setIndex, exerciseIndex) => {
    setIsHovered(setIndex);
    setIsHoveredExercise(exerciseIndex);
  };

  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleMouseLeave = () => {
    const delay = 0;
    timeoutRef.current = setTimeout(() => {
      setIsHovered("");
    }, delay);
  };

  const handleAddSet = (mainindex, index) => {
    let list = addArray;
    list[mainindex]["set"].splice(index + 1, 0, {
      time: "",
      weight: "",
      weightType: "kg",
      height_unit: "cm",
      height: "",
      distance: "",
      distanceType: "m",
      reps: "",
      maxReps: "",
      watts: "",
      rest: "",
      timeType: "sec",
      restType: "sec",
      tempo: "",
    });

    setModalChangeExe(true);
    setaddArray([...list]);
    handleSetScrollCalled(mainindex, index + 1);
  };

  const handleDeleteSet = (mainindex, index) => {
    let list = addArray;
    list[mainindex]["set"].splice(index, 1);
    setModalChangeExe(true);
    setaddArray([...list]);
  };

  const handleDelete = (i) => {
    const delValue = [...addArray];
    delValue.splice(i, 1);
    setModalChangeExe(true);
    setaddArray(delValue);
  };

  const handleArrow = (value, index) => {
    const list = [...addArray];
    list[index]["open"] = value;
    setaddArray(list);
  };

  const handleParameters = (value) => {
    setModalOpen(true);
    setModalOpenForSuperset(false);
    setOuterIndex(value);
    setExsrInfo(addArray[value].parameters);
  };

  const handleChangeParametersInsetFieldValue = (value, outerIndex) => {
    const items = Array.from(addArray);
    const sets = items[outerIndex].set.map((item) => {
      return {
        time: items[outerIndex].parameters.includes("Duration/Pace")
          ? item?.time
          : "",
        weight: items[outerIndex].parameters.includes("Weight")
          ? item?.weight
          : "",
        weightType: item?.weightType,
        reps: items[outerIndex].parameters.includes("Reps") ? item?.reps : "",
        maxReps: items[outerIndex].parameters.includes("Max Reps")
          ? item?.maxReps
          : "",
        watts: items[outerIndex].parameters.includes("Watts")
          ? item?.watts
          : "",
        rest: items[outerIndex].parameters.includes("Rest") ? item?.rest : "",
        distance: items[outerIndex].parameters.includes("Distance/Calories")
          ? item?.distance
          : "",
        distanceType: item?.distanceType,
        timeType: item?.timeType,
        restType: item?.restType,
        tempo: items[outerIndex].parameters.includes("Tempo")
          ? item?.tempo
          : "",
      };
    });
    items[outerIndex].set = sets;
    setaddArray(items);
  };

  const handleChangeParametersInset = (value) => {
    const items = Array.from(addArray);
    if (modalOpenForSuperset) {
      items[outerIndex].superSet[exerIndex].parameters = value;
      setExsrInfo(items[outerIndex].superSet[exerIndex].parameters);
      setaddArray(items);

      setModalChangeExe(true);
      return;
    }
    items[outerIndex].parameters = value;
    setExsrInfo(items[outerIndex].parameters);
    setaddArray(items);
    setModalChangeExe(true);
    handleChangeParametersInsetFieldValue(value, outerIndex);
  };

  const handleArrowSuperSet = (value, mainindex, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["open"] = value;
    setaddArray(list);
  };

  const handleChangeTempo = (e, index, index1) => {
    const { name, value } = e.target;
    if (value.length <= 4) {
      const list = [...addArray];
      list[index]["set"][index1][name] = value;
      setaddArray(list);
      setModalChangeExe(true);
    }
  };

  const handleChange = (e, index, index1) => {
    const { name, value } = e.target;

    const list = [...addArray];
    list[index]["set"][index1][name] = value;

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeSuperSetDes = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index]["superSet"][index1][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeDes = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeSuperSet = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleAddSetCount = (index) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = parseInt(list[index].superset_sets) + 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));

    list[index][name] = targetValue;

    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            time: "",
            weight: "",
            weightType: "kg",
            height_unit: "cm",
            height: "",
            distance: "",
            distanceType: "m",
            reps: "",
            maxReps: "",
            watts: "",
            rest: "",
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleMinusSetCount = (index) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = parseInt(list[index].superset_sets) - 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));

    list[index][name] = targetValue;

    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            time: "",
            weight: "",
            weightType: "kg",
            height_unit: "cm",
            height: "",
            distance: "",
            distanceType: "m",
            reps: "",
            maxReps: "",
            watts: "",
            rest: "",
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeSuperSetCount = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            time: "",
            weight: "",
            weightType: "kg",
            height_unit: "cm",
            height: "",
            distance: "",
            distanceType: "m",
            reps: "",
            maxReps: "",
            watts: "",
            rest: "",
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleExerciseList = (value) => {
    setIsExerciseForSuperSet(false);
    setDetailsData(value);
    setOpenDetails(true);
  };

  const handleSupersetExerciseList = (mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    setIsExerciseForSuperSet(true);
  };

  const handleSelectExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["exercise"] = value;
    list[detailsData]["open"] = true;

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleSelectSupersetExercise = (value) => {
    const list = [...addArray];

    list[detailsData]["superSet"][exerIndex]["exercise"] = value;
    list[detailsData]["superSet"][exerIndex]["description"] =
      value?.instructions;

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  const handleSetScrollCalled = (mainindex, index) => {
    setTimeout(() => {
      const todayCell = document.querySelector(
        `.workout-card-inset[id="${index},${mainindex}"]`,
      );
      if (todayCell)
        todayCell.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  };

  return (
    <div className="container-fluid">
      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}
      {openDetails && (
        <ToshowExercise
          open={openDetails}
          setOpen={setOpenDetails}
          handleChange={handleSelectExercise}
        />
      )}
      {isExerciseForSuperSet && (
        <ToshowExercise
          open={isExerciseForSuperSet}
          setOpen={setIsExerciseForSuperSet}
          handleChange={handleSelectSupersetExercise}
        />
      )}
      {modalOpen && (
        <ParameterModel
          open={modalOpen}
          setOpen={setModalOpen}
          data={exerInfo}
          handleChange={handleChangeParametersInset}
        />
      )}
      <div className="characters mt-2">
        {addArray?.map((data, mainindex) => {
          return (
            <>
              {data?.superSet && data?.superSet.length > 0 ? (
                <>
                  <div
                    style={{ position: "relative" }}
                    className="workout-Superset-card my-2"
                  >
                    <Box>
                      <div className="d-flex align-items-start justify-content-between ">
                        <div className="d-flex align-items-center w-100  mb-2">
                          <div>Superset of</div>
                          <div className="ms-2 cross-icon ">
                            <RemoveCircleIcon
                              onClick={() => handleMinusSetCount(mainindex)}
                              className="diary-icon-plus-minus"
                            />
                          </div>

                          <TextField
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            placeholder="Sets"
                            type="number"
                            value={data.superset_sets}
                            name="superset_sets"
                            disabled
                            onChange={(e) =>
                              handleChangeSuperSetCount(e, mainindex)
                            }
                            InputLabelProps={{
                              className: "textfiels-input-label",
                              shrink: true,
                              style: { fontSize: "14px" },
                            }}
                            //   label="Set"
                            InputProps={{
                              className: "textfiels-input-value",
                              style: { fontSize: "13px", padding: "0" },
                            }}
                            sx={{
                              mx: 1,
                              borderRadius: "5px",
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                              fontSize: "13px",
                              "& input": {
                                padding: "3px 5px",
                                textAlign: "center",
                              },
                              width: "4%",
                            }}
                          />
                          <div className=" cross-icon me-2">
                            <AddCircleIcon
                              onClick={() => handleAddSetCount(mainindex)}
                              className="diary-icon-plus-minus"
                            />
                          </div>
                          <div>sets</div>
                        </div>
                      </div>
                      <div className=" mb-2 ">
                        {data?.superSet?.map((exerData, exerIndex) => (
                          <div className="d-flex  workout-set-card">
                            <Box
                              sx={{
                                position: "relative",
                                width: "100%",
                              }}
                            >
                              <div className="d-flex align-items-center ">
                                <TextField
                                  id="outlined-basic"
                                  variant="outlined"
                                  placeholder="Exercise"
                                  value={exerData?.exercise?.title}
                                  name="Exercise"
                                  onClick={() =>
                                    handleSupersetExerciseList(
                                      mainindex,
                                      exerIndex,
                                    )
                                  }
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: { fontSize: "14px" },
                                  }}
                                  label="Exercise"
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: {
                                      fontSize: "13px",
                                      paddingLeft: "6px",
                                    },
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        {exerData?.exercise?.image
                                          ?.thumbnail_3 && (
                                          <Avatar
                                            sx={{ borderRadius: "5px" }}
                                            alt="User Image"
                                            src={
                                              s3baseUrl +
                                              exerData?.exercise?.image
                                                ?.thumbnail_3
                                            }
                                          />
                                        )}
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <div style={{ fontSize: "16px" }}>
                                          {exerData?.exercise ? (
                                            <EditIcon
                                              fontSize="12px"
                                              sx={{ opacity: 0.5 }}
                                            />
                                          ) : (
                                            <AddIcon sx={{ opacity: 0.5 }} />
                                          )}
                                        </div>
                                      </InputAdornment>
                                    ),
                                    inputProps: {
                                      readOnly: true, // Disable editing
                                    },
                                  }}
                                  sx={{
                                    borderRadius: "5px",

                                    fontSize: "13px",
                                    width: "50%",
                                  }}
                                />
                                <div className="d-flex align-items-center mx-1">
                                  <div className="text-center">
                                    {!exerData?.open ? (
                                      <KeyboardArrowDownIcon
                                        className="bounce"
                                        sx={{
                                          cursor: "pointer",
                                          opacity: 0.5,
                                          fontSize: "20px",
                                        }}
                                        onClick={() => {
                                          handleArrowSuperSet(
                                            true,
                                            mainindex,
                                            exerIndex,
                                          );
                                        }}
                                      />
                                    ) : (
                                      <KeyboardArrowUpIcon
                                        sx={{
                                          cursor: "pointer",
                                          opacity: 0.5,
                                          fontSize: "20px",
                                        }}
                                        onClick={() => {
                                          handleArrowSuperSet(
                                            false,
                                            mainindex,
                                            exerIndex,
                                          );
                                        }}
                                      />
                                    )}
                                  </div>
                                  <Typography
                                    variant="body2"
                                    sx={{ opacity: 0.6 }}
                                  >
                                    {` Sets ${exerData?.set?.length}`}
                                  </Typography>
                                </div>
                              </div>
                              {exerData?.open && (
                                <TextField
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                  placeholder="Instructions"
                                  label="Instructions"
                                  type="number"
                                  value={exerData.description}
                                  name="description"
                                  multiline
                                  rows={2}
                                  onChange={(e) =>
                                    handleChangeSuperSetDes(
                                      e,
                                      mainindex,
                                      exerIndex,
                                    )
                                  }
                                  InputLabelProps={{
                                    className: "textfiels-input-label",
                                    shrink: true,
                                    style: { fontSize: "14px" },
                                  }}
                                  InputProps={{
                                    className: "textfiels-input-value",
                                    style: { fontSize: "14px" },
                                  }}
                                  sx={{
                                    borderRadius: "5px",
                                    mt: 2,
                                    width: "100%",
                                  }}
                                />
                              )}
                              {exerData?.open &&
                                exerData?.set?.map((item, setIndex) => (
                                  <div className="d-flex align-items-center my-3 workout-card-inset">
                                    <Stack
                                      direction="row"
                                      spacing={1}
                                      alignItems="center"
                                      justifyContent="start"
                                    >
                                      <Label
                                        variant={"ghost"}
                                        sx={{ padding: "25px 4px" }}
                                      >
                                        {setIndex + 1}
                                      </Label>
                                      <CloseIcon sx={{ opacity: 0.3 }} />
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="0"
                                        type="number"
                                        value={item?.time}
                                        name="time"
                                        onChange={(e) => {
                                          handleChangeSuperSet(
                                            e,
                                            mainindex,
                                            exerIndex,
                                            setIndex,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        label="Duration"
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <div style={{ fontSize: "11px" }}>
                                                sec
                                              </div>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "17%",
                                        }}
                                      />
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Reps"
                                        type="text"
                                        label="Reps"
                                        value={item?.reps}
                                        name="reps"
                                        onChange={(e) => {
                                          handleChangeSuperSet(
                                            e,
                                            mainindex,
                                            exerIndex,
                                            setIndex,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "13%",
                                        }}
                                      />
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Watts"
                                        type="number"
                                        label="Watts"
                                        value={item?.watts}
                                        name="watts"
                                        onChange={(e) => {
                                          handleChangeSuperSet(
                                            e,
                                            mainindex,
                                            exerIndex,
                                            setIndex,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "13%",
                                        }}
                                      />
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Max Reps"
                                        type="number"
                                        label="Max Reps"
                                        value={item?.maxReps}
                                        name="maxReps"
                                        onChange={(e) => {
                                          handleChangeSuperSet(
                                            e,
                                            mainindex,
                                            exerIndex,
                                            setIndex,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "13%",
                                        }}
                                      />
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "45%",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        placeholder="Weight"
                                        name="weight"
                                        label="Weight"
                                        value={item.weight}
                                        onChange={(e) => {
                                          handleChangeSuperSet(
                                            e,
                                            mainindex,
                                            exerIndex,
                                            setIndex,
                                          );
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="weightType"
                                                value={item?.weightType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                }}
                                              >
                                                <MenuItem value="1rm">
                                                  % 1RM
                                                </MenuItem>
                                                <MenuItem value="body_weight">
                                                  % BW
                                                </MenuItem>
                                                <MenuItem value="kg">
                                                  KG
                                                </MenuItem>
                                                <MenuItem value="lb">
                                                  Pound
                                                </MenuItem>
                                                <MenuItem value="poods">
                                                  Poods
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "45%",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        placeholder="Distance"
                                        name="distance"
                                        label="Distance"
                                        value={item?.distance}
                                        onChange={(e) => {
                                          handleChangeSuperSet(
                                            e,
                                            mainindex,
                                            exerIndex,
                                            setIndex,
                                          );
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="distanceType"
                                                value={item?.distanceType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                }}
                                              >
                                                <MenuItem value="m">
                                                  Meter
                                                </MenuItem>
                                                <MenuItem value="km">
                                                  KM
                                                </MenuItem>
                                                <MenuItem value="mi">
                                                  Mile
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="0"
                                        type="number"
                                        value={item?.rest}
                                        name="rest"
                                        onChange={(e) => {
                                          handleChangeSuperSet(
                                            e,
                                            mainindex,
                                            exerIndex,
                                            setIndex,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        label="Rest"
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <div style={{ fontSize: "11px" }}>
                                                sec
                                              </div>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",

                                          fontSize: "13px",
                                          width: "17%",
                                        }}
                                      />
                                    </Stack>
                                  </div>
                                ))}

                              {exerData?.open && (
                                <div className="row mt-3 d-flex justify-content-center">
                                  <div className="col-md-2 col-lg-1 col-3">
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();

                                        handleArrowSuperSet(
                                          false,
                                          mainindex,
                                          exerIndex,
                                        );
                                      }}
                                      className="w-100 small-contained-set-button"
                                    >
                                      <KeyboardArrowUpIcon
                                        sx={{
                                          cursor: "pointer",
                                          opacity: 0.5,
                                          fontSize: "20px",
                                        }}
                                        onClick={() => {
                                          handleArrowSuperSet(
                                            false,
                                            mainindex,
                                            exerIndex,
                                          );
                                        }}
                                      />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </Box>
                          </div>
                        ))}
                      </div>
                    </Box>
                  </div>
                </>
              ) : (
                <div
                  className=" my-1 workout-set-card w-100"
                  onMouseEnter={() => handleMouseLeave()}
                >
                  <div className=" cross-icon ">
                    <Tooltip title="Remove">
                      <RemoveCircleOutlineIcon
                        onClick={() => handleDelete(mainindex)}
                        className="diary-icon-remove"
                      />
                    </Tooltip>
                  </div>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                    }}
                    onMouseEnter={() => handleMouseLeave()}
                  >
                    <div
                      className="d-flex align-items-start justify-content-between w-100 "
                      onMouseEnter={() => handleMouseLeave()}
                    >
                      <div
                        className="row  w-100"
                        onMouseEnter={() => handleMouseLeave()}
                      >
                        <div
                          className={`col-sm-12 ${"col-md-7"} col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0`}
                        >
                          <div className="exercise-label-box">
                            <span className="outer-label">Exercise</span>
                            <div className="d-flex align-items-center justify-content-between">
                              <div
                                className="exercise-label w-100"
                                onClick={() => handleExerciseList(mainindex)}
                              >
                                <div className="d-flex align-items-center">
                                  {data?.exercise?.image?.thumbnail_3 && (
                                    <Avatar
                                      sx={{ borderRadius: "5px" }}
                                      alt="User Image"
                                      src={
                                        s3baseUrl +
                                        data?.exercise?.image?.thumbnail_3
                                      }
                                    />
                                  )}
                                  <div className="label-text ms-1">
                                    {data?.exercise?.title
                                      ? data?.exercise?.title
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="exercise-action">
                                <div style={{ fontSize: "16px" }}>
                                  {data?.exercise ? (
                                    <div>
                                      <InfoIcon
                                        onClick={() =>
                                          handleClickOpen(data?.exercise?._id)
                                        }
                                        className="d-block"
                                        fontSize="14px"
                                        sx={{
                                          opacity: 0.5,
                                          cursor: "pointer",
                                        }}
                                      />
                                      <EditIcon
                                        onClick={() =>
                                          handleExerciseList(mainindex)
                                        }
                                        fontSize="12px"
                                        sx={{
                                          opacity: 0.5,
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <AddIcon
                                      onClick={() =>
                                        handleExerciseList(mainindex)
                                      }
                                      sx={{
                                        opacity: 0.5,
                                        cursor: "pointer",
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <Button
                            sx={{ textTransform: "inherit" }}
                            size="small"
                            color="primary"
                            variant="contained"
                            className="d-flex align-items-center ms-2 small-contained-dialog-button"
                            onClick={() => {
                              handleArrow(
                                !data?.open ? true : false,
                                mainindex,
                              );
                            }}
                          >
                            {!data?.open ? (
                              <KeyboardArrowDownIcon
                                className="bounce"
                                sx={{
                                  cursor: "pointer",
                                  // opacity: 0.5,
                                  fontSize: "20px",
                                }}
                              />
                            ) : (
                              <KeyboardArrowUpIcon
                                sx={{
                                  cursor: "pointer",
                                  // opacity: 0.5,
                                  fontSize: "20px",
                                }}
                              />
                            )}

                            <Typography
                              variant="body2"
                              sx={{
                                // opacity: 0.6,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {` Sets ${data?.set?.length}`}
                            </Typography>
                          </Button>
                        </div>

                        <div
                          className={`col-sm-12 ${"col-md-5"} col-lg-6 p-0 mt-2 mt-md-0 mt-lg-0 d-flex align-items-center justify-content-start `}
                        >
                          <div
                            className="d-flex align-items-center ms-3 set-parameters "
                            onClick={() => {
                              handleParameters(mainindex);
                            }}
                          >
                            <Icon icon="pajamas:labels" fontSize="10px" />
                            <Typography variant="body2" sx={{ ml: 0.5 }}>
                              {`Parameters`}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </div>

                    {data?.open &&
                      data?.set?.map((item, index1) => (
                        <div
                          className="d-flex align-items-center my-3 workout-card-inset"
                          id={`${index1},${mainindex}`}
                          onMouseEnter={() =>
                            handleMouseEnter(index1, mainindex)
                          }

                          // onMouseLeave={() => handleMouseLeave()}
                        >
                          {is_small_medium_screen() ? (
                            <div>
                              {
                                <div
                                  className="icon-calendar-workout-small-screen"
                                  onMouseEnter={() =>
                                    handleMouseEnter(index1, mainindex)
                                  }
                                >
                                  <Tooltip title="Add set">
                                    <AddIcon
                                      className="add-icon-calendar-workout me-1"
                                      onMouseEnter={() =>
                                        handleMouseEnter(index1, mainindex)
                                      }
                                      onClick={() =>
                                        handleAddSet(mainindex, index1)
                                      }
                                    />
                                  </Tooltip>
                                  <Tooltip
                                    title={`${
                                      data?.set.length > 1
                                        ? "Delete set"
                                        : "Can't be Deleted"
                                    }`}
                                  >
                                    <DeleteIcon
                                      onMouseEnter={() =>
                                        handleMouseEnter(index1, mainindex)
                                      }
                                      className={`${
                                        data?.set.length > 1
                                          ? "del-icon-calendar-workout-working"
                                          : "del-icon-calendar-workout-notwork"
                                      }`}
                                      onClick={
                                        data?.set.length > 1
                                          ? () =>
                                              handleDeleteSet(mainindex, index1)
                                          : () => {}
                                      }
                                    />
                                  </Tooltip>
                                </div>
                              }
                            </div>
                          ) : (
                            <div>
                              {isHovered === index1 &&
                                isHoveredExercise == mainindex && (
                                  <div
                                    className="icon-calendar-workout"
                                    onMouseEnter={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                  >
                                    <Tooltip title="Add Set">
                                      <AddIcon
                                        className="add-icon-calendar-workout me-1"
                                        onMouseEnter={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() =>
                                          handleAddSet(mainindex, index1)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip
                                      title={`${
                                        data?.set.length > 1
                                          ? "Delete Set"
                                          : "Can't be Deleted"
                                      }`}
                                    >
                                      <DeleteIcon
                                        onMouseEnter={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        className={`${
                                          data?.set.length > 1
                                            ? "del-icon-calendar-workout-working"
                                            : "del-icon-calendar-workout-notwork"
                                        }`}
                                        onClick={
                                          data?.set.length > 1
                                            ? () =>
                                                handleDeleteSet(
                                                  mainindex,
                                                  index1,
                                                )
                                            : () => {}
                                        }
                                      />
                                    </Tooltip>
                                  </div>
                                )}
                            </div>
                          )}
                          <div
                            className="d-flex align-items-center w-100"
                            onMouseEnter={() =>
                              handleMouseEnter(index1, mainindex)
                            }
                          >
                            <div className="d-flex align-items-center">
                              <Typography
                                variant="body1"
                                sx={{
                                  padding: "25px 4px",
                                  color: "inherit",
                                  backgroundColor: "#edeff1",
                                  height: "100%",
                                  width: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "7px",
                                }}
                              >
                                {index1 + 1}
                              </Typography>

                              <CloseIcon sx={{ opacity: 0.3 }} />
                            </div>

                            <div className="row w-100">
                              {data.parameters.includes("Duration/Pace") && (
                                <div
                                  className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                >
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    onMouseLeave={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                    onClick={() => handleMouseLeave()}
                                    placeholder="0"
                                    type="number"
                                    value={item?.time}
                                    name="time"
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    label="Duration/Pace"
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                        paddingRight: 0,
                                      },
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Select
                                            id="select-option"
                                            variant="outlined"
                                            size="small"
                                            name="timeType"
                                            value={item?.timeType}
                                            label="Weight Type"
                                            inputProps={{
                                              style: {
                                                padding: 0,
                                              },
                                            }}
                                            onChange={(e) => {
                                              handleChange(
                                                e,
                                                mainindex,
                                                index1,
                                              );
                                            }}
                                            sx={{
                                              "& legend": {
                                                display: "none",
                                              },
                                              "& fieldset": {
                                                top: 0,
                                              },
                                              fontSize: "13px",
                                              border: "none",
                                              "& fieldset": {
                                                border: "none",
                                              },
                                              "& .MuiOutlinedInput-input": {
                                                padding: 0,
                                              },
                                            }}
                                          >
                                            <MenuItem value="sec">sec</MenuItem>
                                            <MenuItem value="min">min</MenuItem>
                                          </Select>
                                        </InputAdornment>
                                      ),
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                      marginTop: "5px",
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes("Reps") && (
                                <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="Reps"
                                    type="text"
                                    onMouseLeave={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                    onClick={() => handleMouseLeave()}
                                    label="Reps"
                                    value={item?.reps}
                                    name="reps"
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: { fontSize: "13px" },
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                      marginTop: "5px",
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes("Watts") && (
                                <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="Watts"
                                    type="number"
                                    onMouseLeave={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                    onClick={() => handleMouseLeave()}
                                    label="Watts"
                                    value={item?.watts}
                                    name="watts"
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: { fontSize: "13px" },
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                      marginTop: "5px",
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes("Max_Reps") && (
                                <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="Max Reps"
                                    type="number"
                                    onMouseLeave={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                    onClick={() => handleMouseLeave()}
                                    label="Max Reps"
                                    value={item?.maxReps}
                                    name="maxReps"
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: { fontSize: "13px" },
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                      marginTop: "5px",
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes("Height") && (
                                <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="0"
                                    type="number"
                                    value={item?.height}
                                    name="height"
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: {
                                        fontSize: "14px",
                                      },
                                    }}
                                    label="Height"
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                        paddingRight: 0,
                                      },
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Select
                                            id="select-option"
                                            variant="outlined"
                                            size="small"
                                            name="height_unit"
                                            value={item?.height_unit || "cm"}
                                            label="Height Type"
                                            inputProps={{
                                              style: {
                                                padding: 0,
                                              },
                                            }}
                                            onChange={(e) => {
                                              handleChange(
                                                e,
                                                mainindex,
                                                index1,
                                              );
                                            }}
                                            sx={{
                                              "& legend": {
                                                display: "none",
                                              },
                                              "& fieldset": {
                                                top: 0,
                                              },
                                              fontSize: "13px",
                                              border: "none",
                                              "& fieldset": {
                                                border: "none",
                                              },
                                              "& .MuiOutlinedInput-input": {
                                                padding: 0,
                                              },
                                            }}
                                          >
                                            <MenuItem value="cm">Cm</MenuItem>
                                            <MenuItem value="ft">Feet</MenuItem>
                                            <MenuItem value="inch">
                                              Inch
                                            </MenuItem>
                                          </Select>
                                        </InputAdornment>
                                      ),
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes("Weight") && (
                                <div className="col-12 col-md-4 col-lg-2 pe-0 py-1">
                                  <TextField
                                    sx={{
                                      borderRadius: "5px",
                                      paddingRight: 0,
                                      width: "100%",
                                      marginTop: "5px",
                                    }}
                                    size="small"
                                    id="custom-input"
                                    variant="outlined"
                                    onMouseLeave={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                    onClick={() => handleMouseLeave()}
                                    placeholder="Weight"
                                    name="weight"
                                    label="Weight"
                                    value={item.weight}
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    type="number"
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                        paddingRight: 0,
                                      },
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Select
                                            id="select-option"
                                            variant="outlined"
                                            size="small"
                                            name="weightType"
                                            value={item?.weightType}
                                            label="Weight Type"
                                            onChange={(e) => {
                                              handleChange(
                                                e,
                                                mainindex,
                                                index1,
                                              );
                                            }}
                                            onMouseLeave={() =>
                                              handleMouseEnter(
                                                index1,
                                                mainindex,
                                              )
                                            }
                                            onClick={() => handleMouseLeave()}
                                            sx={{
                                              "& legend": {
                                                display: "none",
                                              },
                                              "& fieldset": { top: 0 },
                                              fontSize: "13px",
                                              border: "none",
                                              "& fieldset": {
                                                border: "none",
                                              },
                                              "& .MuiOutlinedInput-input": {
                                                padding: 0,
                                              },
                                            }}
                                          >
                                            <MenuItem value="1rm">
                                              % 1RM
                                            </MenuItem>
                                            <MenuItem value="body_weight">
                                              % BW
                                            </MenuItem>
                                            <MenuItem value="kg">KG</MenuItem>
                                            <MenuItem value="lb">
                                              Pound
                                            </MenuItem>
                                            <MenuItem value="poods">
                                              Poods
                                            </MenuItem>
                                          </Select>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes(
                                "Distance/Calories",
                              ) && (
                                <div className="col-12 col-md-3 col-lg-2 pe-0 py-1">
                                  <TextField
                                    sx={{
                                      borderRadius: "5px",
                                      paddingRight: 0,
                                      width: "100%",
                                      marginTop: "5px",
                                    }}
                                    size="small"
                                    id="custom-input"
                                    variant="outlined"
                                    onMouseLeave={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                    onClick={() => handleMouseLeave()}
                                    placeholder={
                                      item?.distanceType == "calories"
                                        ? "Calories"
                                        : "Distance"
                                    }
                                    name="distance"
                                    label="Distance/Calories"
                                    value={item?.distance}
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    type="number"
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                        paddingRight: 0,
                                        paddingLeft: 8,
                                      },
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Select
                                            id="select-option"
                                            variant="outlined"
                                            size="small"
                                            name="distanceType"
                                            value={item?.distanceType}
                                            label="Weight Type"
                                            onChange={(e) => {
                                              handleChange(
                                                e,
                                                mainindex,
                                                index1,
                                              );
                                            }}
                                            onMouseLeave={() =>
                                              handleMouseEnter(
                                                index1,
                                                mainindex,
                                              )
                                            }
                                            onClick={() => handleMouseLeave()}
                                            sx={{
                                              "& legend": {
                                                display: "none",
                                              },
                                              "& fieldset": { top: 0 },
                                              fontSize: "13px",
                                              border: "none",
                                              "& fieldset": {
                                                border: "none",
                                              },
                                              "& .MuiOutlinedInput-input": {
                                                padding: 0,
                                              },
                                            }}
                                          >
                                            <MenuItem value="m">Meter</MenuItem>
                                            <MenuItem value="km">KM</MenuItem>
                                            <MenuItem value="mi">Mile</MenuItem>
                                            <MenuItem value="calories">
                                              Calories
                                            </MenuItem>
                                          </Select>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes("%MHR") && (
                                <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="%MHR"
                                    type="number"
                                    label="%MHR"
                                    value={item?.mhr}
                                    name="mhr"
                                    onChange={(e) => {
                                      handleChangeTempo(e, mainindex, index1);
                                    }}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                      },
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                      marginTop: "5px",
                                      "& .MuiOutlinedInput-input": {
                                        padding: "8px 7px",
                                      },
                                    }}
                                  />
                                </div>
                              )}{" "}
                              {data.parameters.includes("RPE") && (
                                <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="RPE"
                                    label="RPE"
                                    value={item?.RPE}
                                    name="RPE"
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                      },
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                      marginTop: "5px",
                                      "& .MuiOutlinedInput-input": {
                                        padding: "8px 7px",
                                      },
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes("Tempo") && (
                                <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="Tempo"
                                    type="number"
                                    label="Tempo"
                                    value={item?.tempo}
                                    name="tempo"
                                    onChange={(e) => {
                                      handleChangeTempo(e, mainindex, index1);
                                    }}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                      },
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                      marginTop: "5px",
                                      "& .MuiOutlinedInput-input": {
                                        padding: "8px 7px",
                                      },
                                    }}
                                  />
                                </div>
                              )}
                              {data.parameters.includes("Rest") && (
                                <div className="col-12 col-md-3 col-lg-2 pe-0 py-1">
                                  <TextField
                                    id="outlined-basic"
                                    size="small"
                                    variant="outlined"
                                    placeholder="0"
                                    type="number"
                                    value={item?.rest}
                                    name="rest"
                                    onChange={(e) => {
                                      handleChange(e, mainindex, index1);
                                    }}
                                    onMouseLeave={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                    onClick={() => handleMouseLeave()}
                                    InputLabelProps={{
                                      className: "textfiels-input-label",
                                      shrink: true,
                                      style: { fontSize: "14px" },
                                    }}
                                    label="Rest"
                                    InputProps={{
                                      className: "textfiels-input-value",
                                      style: {
                                        fontSize: "13px",
                                        paddingRight: 0,
                                      },
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Select
                                            id="select-option"
                                            variant="outlined"
                                            size="small"
                                            name="restType"
                                            value={item?.restType}
                                            label="Weight Type"
                                            inputProps={{
                                              style: {
                                                padding: 0,
                                              },
                                            }}
                                            onChange={(e) => {
                                              handleChange(
                                                e,
                                                mainindex,
                                                index1,
                                              );
                                            }}
                                            sx={{
                                              "& legend": {
                                                display: "none",
                                              },
                                              "& fieldset": {
                                                top: 0,
                                              },
                                              fontSize: "13px",
                                              border: "none",
                                              "& fieldset": {
                                                border: "none",
                                              },
                                              "& .MuiOutlinedInput-input": {
                                                padding: 0,
                                              },
                                            }}
                                          >
                                            <MenuItem value="sec">sec</MenuItem>
                                            <MenuItem value="min">min</MenuItem>
                                          </Select>
                                        </InputAdornment>
                                      ),
                                    }}
                                    sx={{
                                      borderRadius: "5px",
                                      marginTop: "5px",
                                      fontSize: "13px",
                                      width: "100%",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    {data?.open && (
                      <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        placeholder="Notes"
                        label="Notes"
                        type="number"
                        value={data.description}
                        name="description"
                        multiline
                        rows={2}
                        onChange={(e) => handleChangeDes(e, mainindex)}
                        InputLabelProps={{
                          className: "textfiels-input-label",
                          shrink: true,
                          style: { fontSize: "14px" },
                        }}
                        InputProps={{
                          className: "textfiels-input-value",
                          style: { fontSize: "14px" },
                        }}
                        sx={{
                          borderRadius: "5px",
                          mt: 2,
                          width: "100%",
                        }}
                      />
                    )}
                    {data?.open && (
                      <div className="row mt-3 d-flex justify-content-center">
                        <div className="col-md-2 col-lg-1 col-3">
                          <button
                            onClick={(e) => {
                              e.preventDefault();

                              handleArrow(false, mainindex);
                            }}
                            className="w-100 small-contained-set-button"
                          >
                            <KeyboardArrowUpIcon
                              sx={{
                                cursor: "pointer",
                                opacity: 0.5,
                                fontSize: "20px",
                              }}
                              onClick={() => {
                                handleArrow(false, mainindex);
                              }}
                            />
                          </button>
                        </div>
                      </div>
                    )}
                  </Box>
                </div>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};
export default WorkoutExercisesUI;
